export default {
  // التنقل
  "nav": {
    "home": "الرئيسية",
    "pedagogy": "المنهجية التربوية",
    "events": "الفعاليات",
    "blog": "المدونة",
    "registration": "التسجيل",
    "about": "من نحن",
    "contact": "اتصل بنا",
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "dashboard": "لوحة التحكم"
  },
  
  // صفحة تسجيل الدخول
  "login": {
    "title": "تسجيل الدخول",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "signIn": "تسجيل الدخول",
    "signingIn": "جاري تسجيل الدخول...",
    "error": "خطأ في تسجيل الدخول",
    "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة"
  },
  // الصفحة الرئيسية
  "home": {
    "hero": {
      "title": "المنظومة الوطنية للفرصة الجديدة",
      "subtitle": "دعم شامل للشباب غير المنخرطين في التعليم أو التدريب أو العمل",
      "cta": "اكتشف منظومتنا"
    },
    "stats": {
      "title": "تأثيرنا بالأرقام",
      "students": "الشباب المتدربين",
      "partners": "الشركاء",
      "successRate": "نسبة النجاح",
      "coursesCompleted": "الدورات المكتملة"
    },
    "faq": {
      "title": "هل لديك أسئلة؟",
      "description": "انقر على سؤال للحصول على إجابة فورية من مساعدنا الافتراضي.",
      "questionsTitle": "الأسئلة الشائعة",
      "chatTitle": "مساعد المنظومة الوطنية للفرصة الجديدة",
      "chatWelcome": "مرحبًا! أنا المساعد الافتراضي للمنظومة الوطنية للفرصة الجديدة. كيف يمكنني مساعدتك اليوم؟",
      "chatPlaceholder": "اكتب سؤالك هنا...",
      "questions": {
        
      },
      "answers": {
        },
      "keywords": {
        "start": "تبدأ",
        "accompany": "مرافقة",
        "internship": "تدريب"
      },
      "responses": {
        "start": "للبدء مع المنظومة الوطنية للفرصة الجديدة، أوصيك بزيارة صفحة التسجيل لدينا وملء نموذج الطلب. يمكنك أيضًا زيارة صفحة 'المنهجية' لمعرفة المزيد عن برامج التدريب لدينا.",
        "accompany": "تساعدك منظومة المرافقة الشخصية لدينا على تطوير مهاراتك وتحقيق أهدافك المهنية. يستفيد كل مشارك من موجه مخصص يرشده طوال المسار.",
        "internship": "تقدم المنظومة الوطنية للفرصة الجديدة تدريبًا عمليًا في مختلف القطاعات المهنية بفضل شراكاتنا مع الشركات المحلية والدولية. تتيح لك هذه التدريبات تطبيق معرفتك واكتساب خبرة قيمة.",
        "default": "شكرًا على سؤالك. المنظومة الوطنية للفرصة الجديدة موجودة لمساعدتك في مسارك المهني. لا تتردد في الاتصال بنا مباشرة للحصول على معلومات أكثر تحديدًا أو استكشاف موقعنا الإلكتروني لمعرفة المزيد عن برامجنا."
      }
    },
    "about": {
      "title": "حول المنظومة",
      "description": "المنظومة الوطنية للفرصة الجديدة هي منظومة مرافقة مكثفة لمدة 6 أشهر للشباب غير المنخرطين في التعليم أو التدريب أو العمل. هدفنا هو توفير المهارات اللازمة للاندماج المهني الناجح."
    },
    
    "partners": {
      "title": "شركاؤنا",
      "subtitle": "يثقون بنا ويدعموننا",
      "description": "نعمل بشكل وثيق مع شركاء مؤسسيين، وشركات، ومنظمات المجتمع المدني لتعظيم تأثيرنا.",
      "categories": {
        "all": "الكل",
        "institutional": "مؤسسات",
        "enterprises": "شركات",
        "ngos": "جمعيات"
      },
      "becomePartner": "كن شريكاً",
      "partnersList": {
        "afd": "شريك مؤسسي",
        "mefp": "شريك مؤسسي",
        "aneti": "شريك مؤسسي",
        "atfp": "شريك مؤسسي",
        "lrb": "شريك شركة",
        "slehAyed": "شريك شركة",
        "sancella": "شريك شركة",
        "plastika": "شريك شركة",
        "kmc": "شريك شركة",
        "nakcha": "شريك شركة",
        "kidsLand": "شريك شركة",
        "continental": "شريك شركة",
        "gymClub": "شريك شركة",
        "eurocycles": "شريك شركة",
        "gfi": "شريك شركة",
        "billionnaire": "شريك شركة",
        "mellouli": "شريك شركة",
        "essoukri": "شريك شركة",
        "amt": "شريك شركة",
        "elMouradi": "شريك شركة",
        "decathlon": "شريك شركة",
        "mg": "شريك شركة"
      }
    },
    "whoAreYou": {
      "title": "من أنت؟",
      "subtitle": "حدد ملفك الشخصي لاكتشف المحتوى المناسب لك",
      "young": {
        "title": "شاب",
        "description": "اكتشف دوراتنا التدريبية وسجل",
        "cta": "التسجيل"
      },
      "parent": {
        "title": "والد",
        "description": "اكتشف منهجنا التعليمي وقيمنا",
        "cta": "معرفة المزيد"
      },
      "partner": {
        "title": "شريك",
        "description": "تعاون معنا وشارك في مهمتنا",
        "cta": "تعرف علينا"
      }
    },
    "testimonials": {
      "title": "شهاداتهم",
      "viewAll": "عرض جميع الشهادات"
    },
    "features": {
      "feature1": {
        "title": "تدريب مخصص",
        "description": "مسارات مكيفة حسب احتياجاتك وأهدافك المهنية."
      },
      "feature2": {
        "title": "المرافقة",
        "description": "متابعة فردية من قبل مستشارينا الخبراء."
      },
      "feature3": {
        "title": "الإدماج المهني",
        "description": "فرص حقيقية للتدريب والعمل مع شركائنا."
      }
    },
    "faq": {
      "title": "هل لديك أسئلة؟",
      "description": "انقر على سؤال للحصول على إجابة فورية من مساعدنا الافتراضي.",
      "questionsTitle": "الأسئلة الشائعة",
      "questions": {
        "q0": "كيف يمكنني المشاركة في المنظومة الوطنية للفرصة الجديدة؟",
        "q1": "هل لا تعرف من أين تبدأ؟",
        "q2": "هل ترغب في الحصول على مرافقة في مسارك؟",
        "q3": "هل ترغب في خوض التجربة والقيام بتدريب في مجال تخصصك؟",
        "q4": "ما هي المنظومة الوطنية للفرصة الجديدة؟",
        "q5": "كيف يمكنني التسجيل في المنظومة الوطنية للفرصة الجديدة؟",
        "q6": "كم يوم سأقضي في المنظومة الوطنية للفرصة الجديدة؟",
        "q7": "ماذا سأتعلم في المنظومة الوطنية للفرصة الجديدة؟",
        "q8": "هل التدريب في المنظومة الوطنية للفرصة الجديدة مدفوع أم مجاني؟"
      },
      "answers": {
        "a0": "إذا كنت بين 18 و30 سنة، وليس لديك شهادة ولست تعمل حاليًا، ولا تعرف من أين تبدأ، يمكنك المشاركة في المنظومة الوطنية للفرصة الجديدة من خلال ملء نموذج التسجيل المتاح على موقعنا. بمجرد تقديم طلبك، سيقوم فريقنا بمراجعة ملفك والاتصال بك لمتابعة العملية.",
        "a1": "المنظومة الوطنية للفرصة الجديدة هي مشروع تجريبي في سوسة والقيروان يهدف إلى دعم الشباب غير المنخرطين في التعليم أو التدريب أو العمل من خلال المرافقة الشخصية، التوجيه والفرص العملية.",
        "a2": "بالتأكيد! تتضمن منظومتنا مرافقة شخصية طوال مسارك. سيرشدك موجهونا في كل خطوة لمساعدتك على تحقيق أهدافك.",
        "a3": "نعم، توفر المنظومة الوطنية للفرصة الجديدة فرصًا للتدريب العملي في مختلف المجالات المهنية. تتيح لك شراكاتنا مع الشركات اكتساب خبرة ملموسة في مجال اهتمامك.",
        "a4": "المنظومة الوطنية للفرصة الجديدة هي مشروع تجريبي يهدف إلى تمكين الشباب غير المنخرطين في التعليم أو التدريب أو العمل من خلال المرافقة، التوجيه والفرص العملية. تساعد منظومتنا الشباب غير المنخرطين في التعليم أو التدريب أو العمل على تعزيز المهارات للاندماج بشكل أفضل في سوق العمل ولتطوير قابليتهم للتوظيف.",
        "a5": "للتسجيل في المنظومة الوطنية للفرصة الجديدة، يمكنك الذهاب إلى صفحة التسجيل على موقعنا الإلكتروني، وملء النموذج بمعلوماتك الشخصية، ثم تقديم طلبك. سيقوم فريقنا بمراجعة ملفك والاتصال بك لمتابعة العملية.",
        "a6": "مدة الحضور في المنظومة الوطنية للفرصة الجديدة هي 6 أشهر، مع جلسات منتظمة أسبوعياً من الاثنين إلى الجمعة من الساعة 9 صباحاً حتى الساعة 2 ظهراً والحضور إلزامي. سيتم إبلاغك بالجدول الزمني الدقيق بعد قبولك.",
        "a7": "في المنظومة الوطنية للفرصة الجديدة، ستكتسب مهارات محددة في مجال اهتمامك، ومهارات عامة (التواصل، اللغة الفرنسية، المهارات الرقمية، مهارات الحياة، الحساب والتفكير المنطقي)، بالإضافة إلى مهارات في تقنيات البحث عن عمل. ستستفيد أيضًا من مرافقة شخصية وتدريبات عملية.",
        "a8": "ستستفيد من مرافقة مجانية بالكامل. بالإضافة إلى ذلك، وبفضل شراكتنا مع مكاتب التوظيف، يمكنك الحصول على منحة قدرها 150 دينار شهريًا طوال مسارك لتغطية تكاليف النقل الخاصة بك."
      },
      "keywords": {
        "start": "تبدأ",
        "accompany": "مصحوبًا",
        "internship": "تدريب"
      },
      "responses": {
        "start": "يمكنك البدء بالتسجيل في منظومتنا من خلال صفحة التسجيل. سيقوم فريقنا بالاتصال بك وتوجيهك خلال العملية.",
        "accompany": "نعم، نحن نقدم مرافقة شخصية لكل مشارك. سيكون لديك مرشد مخصص لمساعدتك في تطوير مهاراتك وتحقيق أهدافك.",
        "internship": "بالتأكيد! تتضمن منظومتنا فترة تدريب عملي في شركات شريكة. هذه فرصة ممتازة لاكتساب خبرة عملية في مجال اهتمامك.",
        "default": "شكرًا على سؤالك. المنظومة الوطنية للفرصة الجديدة هي مبادرة تهدف إلى دعم الشباب في تونس من خلال التدريب والتوجيه والفرص العملية. هل يمكنني مساعدتك بمعلومات أكثر تحديدًا؟"
      },
      "chatTitle": "مساعد DNC",
      "chatWelcome": "مرحبًا! أنا مساعد DNC الافتراضي. كيف يمكنني مساعدتك اليوم؟",
      "chatPlaceholder": "اكتب سؤالك هنا..."
    }
  },
  // قسم اللحظات الملتقطة
  "capturedMoments": {
    "title": "لحظات ملتقطة",
    "subtitle": "اكتشف بالصور أبرز لحظات فعالياتنا وأنشطتنا",
    "viewEvents": "شاهد فعالياتنا"
  },
  // الأقسام الجديدة في الصفحة الرئيسية
  "stats": {
    "title": "إحصائياتنا",
    "youth_reached": "الشباب الذين تم الوصول إليهم",
    "youth_reached_desc": "الشباب الذين شاركوا في مختلف أنشطة البرنامج",
    "youth_beneficiaries": "الشباب المستفيدون",
    "youth_beneficiaries_desc": "المشاركون النشطون الذين أكملوا برنامج البرنامج بالكامل",
    "positive_outcomes": "النتائج الإيجابية",
    "positive_outcomes_desc": "الشباب الذين طوروا مهاراتهم ووجدوا تدريباً أو وظيفة أو أطلقوا مشروعهم الخاص",
    "partners": "الشركاء",
    "partners_desc": "المنظمات والشركات التي تدعم مهمتنا"
  },

 
  "usertype": {
    "title": "من أنت؟",
    "youth": "شاب",
    "youth_desc": "ترغب في تطوير مهاراتك والعثور على طريقك",
    "partner": "شريك",
    "partner_desc": "ترغب في التعاون معنا ودعم مهمتنا",
    "parent": "والد",
    "parent_desc": "تبحث عن فهم نهجنا التربوي",
    "signup": "التسجيل",
    "discover": "اكتشف",
    "learn_more": "معرفة المزيد"
  },

  // صفحة المنهجية التربوية
  "pedagogy": {
    "hero": {
      "title": "منهجيتنا التربوية",
      "description": "برنامج مرافقة لمدة 6 أشهر يساعد الشباب على إيجاد طريقهم وبناء مستقبلهم المهني."
    },
    "intro": {
      "title": "نهجنا التربوي",
      "subtitle": "برنامج مرافقة مبتكر للشباب غير المنخرطين في التعليم أو التدريب أو العمل",
      "cardTitle": "مسار مخصص",
      "cardText": "برنامجنا هو مشروع تجريبي في سوسة والقيروان مصمم لتعزيز المهارات وتطوير قابلية التوظيف للشباب غير المنخرطين في التعليم أو التدريب أو العمل.",
      "highlight": "مسار مخصص لكل شاب، يتكيف مع احتياجاته ومشروعه المهني."
    },
    "activeMethod": {
      "title": "التعليم النشط",
      "subtitle": "نهج مبتكر يركز على المتعلم",
      "description": "يضع التعليم النشط الشاب في مركز تعلمه، ويعزز الاستقلالية والمشاركة من خلال التجربة والممارسة.",
      "comparison": {
        "title": "التعليم النشط مقابل التقليدي",
        "traditional": "التعليم التقليدي",
        "active": "التعليم النشط",
        "item1": {
          "traditional": "يركز على المعلم",
          "active": "يركز على المتعلم"
        },
        "item2": {
          "traditional": "نقل سلبي للمعرفة",
          "active": "التعلم من خلال التجربة"
        },
        "item3": {
          "traditional": "تقييم موحد",
          "active": "تقييم مستمر ومخصص"
        },
        "item4": {
          "traditional": "بيئة رسمية وصارمة",
          "active": "بيئة مرنة وتعاونية"
        },
        "item5": {
          "traditional": "التركيز على الحفظ",
          "active": "التركيز على حل المشكلات"
        }
      },
      "benefits": {
        "title": "فوائد للشباب  المنخرطين",
        "item1": {
          "title": "زيادة الدافع",
          "description": "المتعلمون أكثر انخراطًا لأنهم يشاركون بنشاط في تعلمهم"
        },
        "item2": {
          "title": "تطوير الاستقلالية",
          "description": "تعلم المبادرة والمسؤولية"
        },
        "item3": {
          "title": "المهارات العملية",
          "description": "اكتساب مهارات قابلة للتطبيق مباشرة في العالم المهني"
        },
        "item4": {
          "title": "الثقة بالنفس",
          "description": "تعزيز احترام الذات من خلال النجاحات الملموسة"
        }
      }
    },
    "axes": {
      "title": "محاور المرافقة الخمسة",
      "subtitle": "برنامجنا منظم حول 5 محاور متكاملة للتنمية الشاملة",
      "tableHeader": "تفاصيل المرافقة",
      "axis1": {
        "title": "المرافقة النفسية",
        "description": "دعم لإدارة المشاعر بشكل أفضل وتعزيز الثقة بالنفس.",
        "details": [
          "جلسات فردية مع أخصائي نفسي",
          "ورش عمل لإدارة التوتر",
          "تطوير احترام الذات",
          "تقنيات الاسترخاء والرفاهية"
        ]
      },
      "axis2": {
        "title": "مهارات الحياة",
        "description": "تطوير المهارات الشخصية للاندماج في المجتمع وعالم العمل.",
        "details": [
          "التواصل بين الأشخاص",
          "العمل الجماعي",
          "حل المشكلات",
          "إدارة الوقت",
          "اتخاذ القرارات"
        ]
      },
      "axis3": {
        "title": "المهارات الأساسية",
        "description": "تعزيز المهارات الأساسية اللازمة للنجاح.",
        "details": [
          "الحساب والتفكير المنطقي",
          "التواصل الكتابي والشفهي",
          "اللغات الأجنبية",
          "المهارات الرقمية",
          "الثقافة العامة"
        ]
      },
      "axis4": {
        "title": "فاعل في حياتي، فاعل في مدينتي",
        "description": "التوعية والمشاركة من خلال الفعاليات والأنشطة المدنية.",
        "details": [
          "المشاريع المجتمعية",
          "التوعية البيئية",
          "المشاركة في الفعاليات الثقافية",
          "أعمال التضامن",
          "اكتشاف التراث المحلي"
        ]
      },
      "axis5": {
        "title": "المرافقة المهنية",
        "description": "تقنيات البحث عن عمل، كتابة السيرة الذاتية، التدريب والسلوك المهني.",
        "details": [
          "كتابة السيرة الذاتية ورسالة التحفيز",
          "تقنيات مقابلة العمل",
          "البحث عن تدريب وعمل",
          "تطوير شبكة مهنية",
          "الانغماس في بيئة العمل"
        ]
      }
    },
    "journey": {
      "title": "المسار في 4 مراحل",
      "subtitle": "مسار منظم لتعظيم فرص نجاحك",
      "step1": {
        "title": "الاندماج",
        "description": "اكتشاف البرنامج، تقييم شخصي ومشروع أولي.",
        "details": [
          "الاستقبال وتقديم البرنامج",
          "تقييم المهارات الأولية",
          "تحديد الأهداف الشخصية",
          "وضع خطة المرافقة"
        ]
      },
      "step2": {
        "title": "البناء",
        "description": "تطوير المهارات والانغماس في بيئة العمل.",
        "details": [
          "ورش عمل لتطوير المهارات",
          "تدريبات استكشافية في الشركات",
          "مشاريع جماعية",
          "متابعة منتظمة مع المرجعيين",
          "بناء مشروع مهني"
        ]
      },
      "step3": {
        "title": "التصديق",
        "description": "إنهاء المشروع المهني والتحضير للإدماج.",
        "details": [
          "تدريب تطبيقي في الشركة",
          "التحقق من المكتسبات",
          "إنهاء المشروع المهني",
          "التحضير للخروج من البرنامج",
          "إعداد خطة عمل للفترة القادمة",
          "تقديم وعرض المسار"
        ]
      },
      "step4": {
        "title": "ما بعد المسار",
        "description": "المتابعة والحفاظ على الدافع بعد البرنامج.",
        "details": [
          "متابعة 6 أشهر بعد الخروج",
          "المساعدة في البحث عن عمل أو تكوين",
          "اتصالات منتظمة مع المرجعي",
          "الوصول إلى موارد وشبكة البرنامج",
          "متابعة خطة العمل المعدة"
        ]
      }
    },
    "roles": {
      "title": "الأدوار الرئيسية في المرافقة",
      "subtitle": "فريق متعدد التخصصات مكرس لنجاحك",
      "role1": {
        "title": "المدرب المرجعي",
        "description": "محاورك الرئيسي طوال المسار.",
        "details": [
          "متابعة شخصية ومنتظمة",
          "تنشيط الجلسات",
          "تنسيق مسارك",
          "تكييف البرنامج حسب احتياجاتك",
          "نقطة الاتصال الرئيسية"
        ]
      },
      "role2": {
        "title": "مدرب الشركة",
        "description": "يسهل اندماجك في العالم المهني.",
        "details": [
          "البحث عن فرص التدريب والعمل",
          "تنشيط جلسات تقنيات البحث عن عمل",
          "التحضير للمقابلات",
          "الوساطة مع الشركات",
          "المتابعة خلال فترات الانغماس"
        ]
      },
      "role3": {
        "title": "المستشار النفسي والاجتماعي",
        "description": "يساعدك على التغلب على العقبات الشخصية.",
        "details": [
          "الدعم العاطفي والنفسي",
          "المساعدة في حل المشكلات الشخصية",
          "تطوير الثقة بالنفس",
          "التوجيه نحو الخدمات المتخصصة عند الضرورة"
        ]
      },
      "role4": {
        "title": "مسؤول تنسيق المشاريع",
        "description": "ينظم الأنشطة الجماعية والمشاريع.",
        "details": [
          "تصميم وتنشيط ورش العمل",
          "تنظيم الفعاليات",
          "تنسيق المشاريع الجماعية",
          "تطوير الشراكات"
        ]
      }
    },
    "skills": {
      "title": "المهارات الأساسية",
      "subtitle": "في نهاية المسار، ستكون قد طورت هذه المهارات الثلاث الأساسية",
      "skill1": {
        "title": "الاستقلالية",
        "description": "القدرة على أخذ المبادرة، التنظيم والعمل بشكل مستقل في حياتك الشخصية والمهنية."
      },
      "skill2": {
        "title": "الاندماج الاجتماعي",
        "description": "القدرة على الاندماج في بيئات اجتماعية مختلفة، التواصل بفعالية والعمل ضمن فريق."
      },
      "skill3": {
        "title": "بناء مشروع حياة",
        "description": "القدرة على تحديد أهدافك، تخطيط الخطوات لتحقيقها والتكيف مع التغييرات."
      }
    },
    "cta": {
      "title": "مستعد لبناء مستقبلك؟",
      "text": "انضم إلى المنظومة الوطنية للفرصة الجديدة واستفد من مرافقة مخصصة لنجاح إدماجك المهني.",
      "button": "الانضمام إلى المنظومة"
    }
  },
  // صفحة الفعاليات
  "events": {
    "upcoming": "القادمة",
    "past": "السابقة",
    "title": "الفعاليات",
    "subtitle": "اكتشف فعالياتنا السابقة والقادمة",
    "upcomingEvents": "الفعاليات القادمة",
    "pastEvents": "الفعاليات السابقة",
    "pastEvent": "فعالية سابقة",
    "viewDetails": "عرض التفاصيل",
    "closeDetails": "إغلاق",
    "addEvent": "إضافة فعالية",
    "noEvents": "لم يتم العثور على فعاليات",
    "date": "التاريخ",
    "time": "الوقت",
    "location": "المكان",
    "category": "الفئة",
    "status": "الحالة",
    "gallery": "معرض الصور",
    "outcomes": "النتائج والتأثير",
    "description": "الوصف",
    "eventInfo": "معلومات الفعالية",
    "backToEvents": "العودة إلى الفعاليات",
    "share": "مشاركة",
    "tags": {
      "health": "صحة",
      "culture": "ثقافة",
      "sports": "رياضة",
      "professional": "مهني"
    },
    "categories": {
      "workshop": "ورشة عمل",
      "conference": "مؤتمر",
      "seminar": "ندوة",
      "training": "تدريب",
      "meeting": "اجتماع",
      "other": "آخر"
    },
    "filters": {
      "title": "تصفية الفعاليات",
      "all": "الكل",
      "upcoming": "القادمة",
      "past": "السابقة",
      "workshop": "ورشة عمل",
      "seminar": "ندوة",
      "conference": "مؤتمر",
      "health": "صحة",
      "culture": "ثقافة",
      "sports": "رياضة",
      "professional": "مهني",
      "training": "تدريب",
      "internal": "داخلي",
      "external": "خارجي"
    },
    "form": {
      "title": "العنوان",
      "description": "الوصف",
      "date": "التاريخ",
      "time": "الوقت",
      "location": "المكان",
      "category": "الفئة",
      "type": "النوع",
      "status": "الحالة",
      "mainImage": "الصورة الرئيسية",
      "gallery": "معرض الصور",
      "outcomes": "النتائج",
      "imageUrl": "رابط الصورة",
      "addImage": "إضافة صورة",
      "addOutcome": "إضافة نتيجة",
      "outcomeExample": "مثال: حضر 50 مشاركًا الفعالية",
      "selectCategory": "اختر فئة",
      "selectType": "اختر نوعًا",
      "selectStatus": "اختر حالة",
      "submit": "إرسال",
      "cancel": "إلغاء",
      "health": "صحة",
      "culture": "ثقافة",
      "sports": "رياضة",
      "professional": "مهني",
      "internal": "داخلي",
      "training": "تدريب",
      "external": "خارجي"
    },
    "closeForm": "إغلاق النموذج"
  },
  // صفحة التسجيل
  "registration": {
    "title": "التسجيل في المنظومة",
    "subtitle": "انضم إلى المنظومة الوطنية للفرصة الجديدة",
    "info": "المنظومة الوطنية للفرصة الجديدة مفتوحة للشباب من 18 إلى 29 عامًا، بدون عمل وبدون تدريب حالي.",
    "form": {
      "personalInfo": "المعلومات الشخصية",
      "firstName": "الاسم الأول",
      "lastName": "اللقب",
      "dob": "تاريخ الميلاد",
      "gender": "الجنس",
      "male": "ذكر",
      "female": "أنثى",
      "other": "آخر",
      "contactInfo": "معلومات الاتصال",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "address": "العنوان",
      "city": "المدينة",
      "education": "التعليم",
      "highestDegree": "أعلى شهادة",
      "schoolName": "اسم المؤسسة التعليمية",
      "graduationYear": "سنة التخرج",
      "motivation": "الدافع",
      "motivationText": "لماذا ترغب في الانضمام إلى المنظومة الوطنية للفرصة الجديدة؟",
      "expectations": "ما الذي تتوقعه من هذا البرنامج؟",
      "hearAboutUs": "كيف سمعت عنا؟",
      "submit": "تقديم طلبي",
      "required": "حقل مطلوب",
      "success": "تم تقديم طلبك بنجاح!",
      "error": "حدث خطأ. يرجى المحاولة مرة أخرى."
    }
  },
  // صفحة من نحن
  "about": {
    "hero": {
      "title": "من نحن",
      "subtitle": "اكتشف مهمتنا وفريقنا وشركائنا"
    },
    "common": {
      "more": "عرض المزيد",
      "less": "عرض أقل"
    },
    "values": {
      "title": "قيمنا",
      "subtitle": "المبادئ التي توجه عملنا",
      "values": [
        {
          "title": "التميز",
          "description": "نسعى للتميز في جميع برامجنا وخدماتنا.",
          "icon": "FaAward"
        },
        {
          "title": "الشمولية",
          "description": "نؤمن بتكافؤ الفرص لجميع الشباب.",
          "icon": "FaUsers"
        },
        {
          "title": "الابتكار",
          "description": "نتبنى أساليب مبتكرة لحل التحديات.",
          "icon": "FaLightbulb"
        },
        {
          "title": "الالتزام",
          "description": "نحن ملتزمون بنجاح كل مشارك.",
          "icon": "FaHandshake"
        }
      ]
    },
    "iecd": {
      "title": "المعهد الأوروبي للتعاون والتنمية",
      "subtitle": "شريك رئيسي في التدريب المهني والإدماج الاجتماعي",
      "description": "المعهد الأوروبي للتعاون والتنمية هو منظمة تضامن دولية تأسست عام 1988 تنفذ مشاريع التنمية الاقتصادية والبشرية في 18 دولة، مع اهتمام خاص بتدريب وإدماج الشباب مهنياً.",
      "stats": {
        "countries": "بلدان",
        "beneficiaries": "مستفيدون",
        "projects": "مشاريع"
      },
      "mission": {
        "title": "مهمتنا",
        "description": "بناء بيئات تمكّن كل شخص من بناء مستقبله ومجتمع أكثر عدالة."
      },
      "domains": {
        "title": "3 مجالات للتدخل",
        "training": "التدريب والإدماج المهني",
        "entrepreneurship": "ريادة الأعمال",
        "education": "التعليم"
      },
      "tunisia": {
        "title": "المعهد الأوروبي للتعاون والتنمية في تونس",
        "since": "متواجد منذ",
        "inCountry": "في البلاد",
        "expectedBeneficiaries": "مستفيد متوقع",
        "projects": "مشاريع",
        "localPartners": "شركاء تشغيليين محليين",
        "businessPartners": "شركاء من الشركات ومنظمات المجتمع المدني",
        "trainingCenters": "مراكز تدريب"
      }
    },
    "dnc": {
      "title": "المنظومة الوطنية للفرصة الجديدة",
      "subtitle": "منظومة للإدماج الاجتماعي والمهني للشباب",
      "description": "المنظومة الوطنية للفرصة الجديدة هي منظومة تهدف إلى تعزيز الإدماج الاجتماعي والمهني للشباب في وضعية هشاشة في تونس، من خلال توفير مسار تدريب ومرافقة متكامل.",
      "objective": {
        "title": "الهدف",
        "content": "مرافقة الشباب غير المنخرطين في التعليم أو التوظيف أو التدريب (NEET) الذين تتراوح أعمارهم بين 18 و30 عامًا نحو الإدماج المهني من خلال مسار مخصص."
      },
      "context": {
        "title": "السياق",
        "unemployment": "معدل بطالة الشباب: 35.4%",
        "neets": "~ 31.8% من الشباب غير منخرطين في التعليم أو التوظيف أو التدريب",
        "women": "معدل بطالة الشابات: 38.7%",
        "source": "المصدر: منظمة العمل الدولية (OIT)"
      },
      "framework": {
        "title": "إطار المشروع",
        "steps": {
          "step1": {
            "title": "تحليل المشروع",
            "date": "2022"
          },
          "step2": {
            "title": "المجموعة التجريبية الأولى",
            "date": "مارس 2024"
          },
          "step3": {
            "title": "افتتاح المنظومة الوطنية للفرصة الجديدة سوسة",
            "date": "20 أغسطس 2024"
          },
          "step4": {
            "title": "افتتاح المنظومة الوطنية للفرصة الجديدة القيروان",
            "date": "6 ديسمبر 2024"
          }
        }
      },
      "details": {
        "title": "المنظومة الوطنية للفرصة الجديدة - سوسة والقيروان",
        "duration": "مدة المشروع: 2024 - 2027",
        "period": "خلال الفترة 2024 - 2027",
        "beneficiaries": "1000 شاب غير منخرط في التعليم أو التوظيف أو التدريب تتراوح أعمارهم بين 18 و30 عامًا (40% منهم من النساء) يتم مرافقتهم:",
        "locations": "مكاتب التشغيل والعمل المستقل ودور الشباب في سوسة والقيروان",
        "professionals": "30 مهني من مكاتب التشغيل والعمل المستقل ودور الشباب في سوسة والقيروان تم تعزيز قدراتهم وتدريبهم على نهج \"الفرصة الجديدة\"",
        "approach": "مرافقة مخصصة للشباب في تحديد المشروع المهني",
        "training": "تدريب مستمر للعاملين مع الشباب على الممارسات التربوية للمرافقة والتوجيه المهني",
        "impact": {
          "title": "الأثر المتوقع:",
          "rate": ">50% يجدون وظيفة، أو يتابعون تدريبًا، أو يبدأون نشاطًا رياديًا",
          "perspectives": "آفاق 2024:",
          "activities": "نشر الأنشطة، استقبال 200 شاب",
          "network": "تطوير شبكة الشركات",
          "government": "نشر البرنامج لدى الدولة التونسية"
        }
      },
      "summary": {
        "title": "المنظومة الوطنية للفرصة الجديدة",
        "duration": "4 سنوات",
        "duration_period": "مايو 2024 - مايو 2027",
        "centers": "2 مركز",
        "centers_locations": "سوسة القيروان",
        "beneficiaries": "1000",
        "beneficiaries_details": "شاب غير منخرط في التعليم أو التوظيف أو التدريب 18-30 سنة"
      }
    },
    "history": {
      "title": "تاريخنا",
      "subtitle": "المراحل الرئيسية لتطورنا",
      "milestone1": {
        "year": "2022",
        "content": "تحليل المشروع"
      },
      "milestone2": {
        "year": "مارس 2024",
        "content": "المجموعة التجريبية الأولى"
      },
      "milestone3": {
        "year": "20 أغسطس 2024",
        "content": "افتتاح المنظومة الوطنية للفرصة الجديدة سوسة"
      },
      "milestone4": {
        "year": "6 ديسمبر 2024",
        "content": "افتتاح المنظومة الوطنية للفرصة الجديدة القيروان"
      }
    },
    "team": {
      "title": "فريقنا",
      "subtitle": "الأشخاص الذين يقودون مهمتنا",
      "categories": {
        "all": "جميع الأعضاء",
        "management": "إدارة",
        "coach": "المدربون",
        "pedagogique": "التربية",
        "entreprise": "المؤسسات",
        "psycho": "الدعم النفسي والاجتماعي",
        "administration": "إدارة",
        "communication": "التواصل"
      },
      "members": [
        {
          "name": "وفاء فتح لله",
          "role": "مسؤولة DNC",
          "description": "إدارة مشروع DNC وتنسيق الفرق.",
          "image": "/image/apropos/equipe/ouafa.jpg",
          "category": "management"
        },
        {
          "name": "أسماء مراد",
          "role": "منسقة تربوية",
          "description": "إشراف على برامج التكوين ومرافقة المستفيدين.",
          "image": "/image/apropos/equipe/asma.jpg",
          "category": "pedagogique"
        },
        {
          "name": "زينب شنيور",
          "role": "منسقة المؤسسات والشراكات",
          "description": "إدارة الشراكات والعلاقات مع المؤسسات.",
          "image": "/image/apropos/equipe/zeineb.jpg",
          "category": "entreprise"
        },
        {
          "name": "أحمد عبيدي",
          "role": "مسؤول تنسيق المشاريع",
          "description": "تنسيق المشاريع ومتابعة الأنشطة.",
          "image": "/image/apropos/equipe/ahmed.jpg",
          "category": "pedagogique"
        },
        {
          "name": "رانية عكروت",
          "role": "مستشارة نفسية واجتماعية",
          "description": "دعم نفسي ومرافقة المستفيدين.",
          "image": "/image/apropos/equipe/rania.jpg",
          "category": "psycho"
        },
        {
          "name": "نور نصراوي",
          "role": "مسؤولة المشروع",
          "description": "إدارة إدارية ومتابعة الأنشطة.",
          "image": "/image/apropos/equipe/nour.jpg",
          "category": "administration"
        },
        {
          "name": "أحمد بن العربي",
          "role": "مدرب مرجعي",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/ahmedbl.jpg",
          "category": "coach"
        },
        {
          "name": "إشراف برهومي",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/ichraf.jpg",
          "category": "coach"
        },
        {
          "name": "نضال فرج",
          "role": "مدرب مرجعي",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/nidhal.jpg",
          "category": "coach"
        },
        {
          "name": "طاهر قرواشي",
          "role": "مدرب مرجعي",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/taher.jpg",
          "category": "coach"
        },
        {
          "name": "أمنة بن سعد",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/emna.jpg",
          "category": "coach"
        },
        {
          "name": "ريم الهواري",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/rim.jpg",
          "category": "coach"
        },
        {
          "name": "صالح الظاهري",
          "role": "مدرب مرجعي",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/salah.jpg",
          "category": "coach"
        },
        {
          "name": "فريال رزقاني",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/feryel.jpg",
          "category": "coach"
        },
        {
          "name": "إيمان حاجّي",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/imen.jpg",
          "category": "coach"
        },
        {
          "name": "مريم الشايب",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/mariem.jpg",
          "category": "coach"
        },
        {
          "name": "محمد طاهر صديري",
          "role": "مدرب مرجعي",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/mohamed.jpg",
          "category": "coach"
        },
        {
          "name": "أميمة بن كالية",
          "role": "مدربة مرجعية",
          "description": "مرافقة فردية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/oumayma.jpg",
          "category": "coach"
        },
        {
          "name": "مجدي حسناوي",
          "role": "عامل متعدد المهام",
          "description": "دعم إداري وخدمات لوجستية.",
          "image": "/image/apropos/equipe/majdi.jpg",
          "category": "administration"
        },
        {
          "name": "فارس حبيببوعلاڨ ",
          "role": "مسؤول إداري ومالي",
          "description": "إدارة المشروع إدارياً ومادياً.",
          "image": "/image/apropos/equipe/fares.jpg",
          "category": "administration"
        },
        {
          "name": "أناغيم زنينة",
          "role": "مساعد إداري",
          "description": "دعم إداري وإدارة الوثائق.",
          "image": "/image/apropos/equipe/anaguim.jpg",
          "category": "administration"
        },
        {
          "name": "إكزافييه برينيو",
          "role": "مسؤول العمليات في تونس",
          "description": "إشراف على العمليات في تونس والتنسيق المحلي.",
          "image": "/image/apropos/equipe/xavier.jpg",
          "category": "management"
        },
        {
          "name": "ميسون بناني",
          "role": "مدرب مؤسساتي",
          "description": "مرافقة مهنية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/maysson.jpg",
          "category": "entreprise"
        },
        {
          "name": "محمد أمين السالمي",
          "role": "مدرب مؤسساتي",
          "description": "مرافقة مهنية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/mohameds.jpg",
          "category": "entreprise"
        },
        {
          "name": "أمين خلفاوي",
          "role": "مدرب مؤسساتي",
          "description": "مرافقة مهنية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/amine.jpg",
          "category": "entreprise"
        },
        {
          "name": "سماح بن حسان",
          "role": "مدرب مؤسساتي",
          "description": "مرافقة مهنية وتطوير الكفاءات.",
          "image": "/image/apropos/equipe/sameh.jpg",
          "category": "entreprise"
        },
        {
          "name": "زياد حناشي",
          "role": "منسق التواصل والفعاليات",
          "description": "إدارة التواصل وتنظيم الفعاليات.",
          "image": "/image/apropos/equipe/zied.jpg",
          "category": "communication"
        },
        {
          "name": "فاطمة ممني",
          "role": "مسؤولة موقع القيروان",
          "description": "إدارة موقع القيروان والتنسيق المحلي.",
          "image": "/image/apropos/equipe/fatma.jpg",
          "category": "management"
        },
        {
          "name": "باهر عوني",
          "role": "مساعد إداري",
          "description": "دعم إداري وإدارة الوثائق.",
          "image": "/image/apropos/equipe/baher.jpg",
          "category": "administration"
        }
      ]
    },
    
    "partners": {
      "title": "شركاؤنا",
      "subtitle": "يثقون بنا ويدعموننا",
      "description": "نعمل بشكل وثيق مع شركاء مؤسسيين، وشركات، ومنظمات المجتمع المدني لتعظيم تأثيرنا.",
      "categories": {
        "all": "الكل",
        "institutional": "مؤسسات",
        "enterprises": "شركات",
        "ngos": "جمعيات"
      },
      "becomePartner": "كن شريكاً",
      "partnersList": {
        "afd": "شريك مؤسسي",
        "mefp": "شريك مؤسسي",
        "aneti": "شريك مؤسسي",
        "atfp": "شريك مؤسسي",
        "lrb": "شريك شركة",
        "slehAyed": "شريك شركة",
        "sancella": "شريك شركة",
        "plastika": "شريك شركة",
        "kmc": "شريك شركة",
        "nakcha": "شريك شركة",
        "kidsLand": "شريك شركة",
        "continental": "شريك شركة",
        "gymClub": "شريك شركة",
        "eurocycles": "شريك شركة",
        "gfi": "شريك شركة",
        "billionnaire": "شريك شركة",
        "mellouli": "شريك شركة",
        "essoukri": "شريك شركة",
        "amt": "شريك شركة",
        "elMouradi": "شريك شركة",
        "decathlon": "شريك شركة",
        "mg": "شريك شركة",
        "rfiki": "شريك جمعية",
        "ftartchy": "شريك جمعية",
        "awledna": "شريك جمعية"
      }
    },
    "values": {
      "title": "قيمنا",
      "subtitle": "المبادئ التي توجه عملنا",
      "values": [
        
          {
            "title": "الاحترام",
            "description": "نحترم كرامة وتفرد كل شخص، من خلال تقدير التنوع وتعزيز بيئة شاملة.",
            "icon": "FaAward"
          },
          {
            "title": "الالتزام",
            "description": "نحن ملتزمون بشكل كامل بمهمتنا، بشغف وعزم، لتحقيق نتائج مستدامة وذات مغزى.",
            "icon": "FaUsers"
          },
           {
            "title": "الابتكار",
            "description": "نشجع الإبداع والابتكار في نهجنا التربوي وأساليب المرافقة لدينا.",
            "icon": "FaLightbulb"
          },
        {
            "title": "التعاون",
            "description": "نؤمن بقوة العمل الجماعي والتعاون مع شركائنا لتعظيم تأثيرنا.",
            "icon": "FaHandshake"
          }
        
      ]
    }
  },
  // صفحة الاتصال
  "contact": {
    "title": "اتصل بنا",
    "subtitle": "نحن هنا للإجابة على أسئلتك ومرافقتك في مسارك",
    "getInTouch": "معلومات الاتصال",
    "sendMessage": "أرسل لنا رسالة",
    "followUs": "تابعنا",
    "viewLargerMap": "عرض الخريطة بحجم أكبر",
    "info": {
      "address": {
        "title": "العنوان",
        "content": "عمارة حبيبة، شارع جوهرة الساحل - خزامة - سوسة"
      },
      "phone": {
        "title": "الهاتف",
        "content": "56069069 (سوسة) / 51022929 (القيروان)"
      },
      "email": {
        "title": "البريد الإلكتروني",
        "content": "dispositifnouvellechance@gmail.com"
      },
      "hours": {
        "title": "ساعات العمل",
        "content": "الاثنين - الجمعة: 9:00 - 17:00"
      }
    },
    "form": {
      "name": "الاسم الكامل",
      "email": "البريد الإلكتروني",
      "subject": "الموضوع",
      "message": "رسالتك",
      "send": "إرسال الرسالة",
      "success": {
        "title": "تم إرسال الرسالة!",
        "message": "شكرا لرسالتك. سنرد عليك في أقرب وقت ممكن."
      },
      "error": "حدث خطأ. يرجى المحاولة مرة أخرى."
    },
    "locations": {
      "sousse": "سوسة",
      "kairouan": "القيروان",
      "sousse_address": "عمارة حبيبة، شارع جوهرة الساحل - خزامة - سوسة",
      "kairouan_address": "شارع طارق ابن زياد - القيروان"
    },
    
  },
  // المسؤول
  "admin": {
    "dashboard": "لوحة التحكم",
    "applications": "الطلبات",
    "events": "إدارة الفعاليات",
    "content": "إدارة المحتوى",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "stats": "الإحصائيات",
    "logout": "تسجيل الخروج",
    "login": {
      "title": "مساحة الإدارة",
      "subtitle": "قم بتسجيل الدخول للوصول إلى لوحة التحكم",
      "username": "اسم المستخدم",
      "password": "كلمة المرور",
      "rememberMe": "تذكرني",
      "forgotPassword": "نسيت كلمة المرور؟",
      "signIn": "تسجيل الدخول",
      "signingIn": "جاري تسجيل الدخول...",
      "accessNote": "الوصول محدود للموظفين المصرح لهم فقط",
      "invalidCredentials": "اسم المستخدم أو كلمة المرور غير صحيحة",
      "usernamePlaceholder": "اسم المستخدم",
      "passwordPlaceholder": "كلمة المرور"
    }
  },
  // مكونات مشتركة
  "common": {
    "loading": "جاري التحميل...",
    "error": "حدث خطأ",
    "retry": "إعادة المحاولة",
    "back": "العودة",
    "next": "التالي",
    "previous": "السابق",
    "readMore": "قراءة المزيد",
    "showMore": "عرض المزيد",
    "showLess": "عرض أقل",
    "all": "الكل",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "search": "بحث",
    "filter": "تصفية",
    "notFound": "الصفحة غير موجودة",
    "notFoundMessage": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    "goHome": "العودة إلى الصفحة الرئيسية",
    "more": "عرض المزيد",
    "less": "عرض أقل",
    "darkMode": "الوضع المظلم",
    "lightMode": "الوضع المضيء"
  },
  
  "notFound": {
    "title": "الصفحة غير موجودة",
    "message": "عفواً! يبدو أن الصفحة التي تبحث عنها قد اختفت.",
    "backHome": "العودة إلى الصفحة الرئيسية"
  },
  // تذييل الصفحة
  "footer": {
    "description": "المنظومة الوطنية للفرصة الجديدة هي منظومة مرافقة مكثفة للشباب غير المنخرطين في التعليم أو التدريب أو العمل، تهدف إلى تسهيل اندماجهم المهني.",
    "quickLinks": "روابط سريعة",
    "contactUs": "اتصل بنا",
    "address": "123 شارع المستقبل، تونس، تونس",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "newsletter": "النشرة الإخبارية",
    "newsletterText": "اشترك في نشرتنا الإخبارية لتلقي آخر الأخبار والفعاليات.",
    "emailPlaceholder": "عنوان بريدك الإلكتروني",
    "subscribe": "اشتراك",
    "rights": "جميع الحقوق محفوظة."
  }
};
